import { default as _91_46_46_46slug_93EQm4eIoT6hMeta } from "/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/pages/[...slug].vue?macro=true";
import { default as _404GIIdljHk7qMeta } from "/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/pages/404.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/pages/[...slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/runner/work/zotlo-3platform-frontend-generate/zotlo-3platform-frontend-generate/pages/404.vue")
  }
]